export default __webpack_public_path__ + "static/media/stop.6ff972fa.svg";